/*
 * Author: Roger
 * File Created: Monday, 24-11-04 01:41 pm
 * Last Modified: Monday, 24-11-04 01:41 pm, by Roger
 */

const Alert = () => {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45 44" fill="none" data-sentry-element="svg" data-sentry-component="Alert" data-sentry-source-file="index.tsx">
      <circle cx="22.5" cy="22.001" r="22" fill="#EF9C40" data-sentry-element="circle" data-sentry-source-file="index.tsx" />
      <rect x="20.2998" y="9.46094" width="4.4" height="17.6" rx="2.2" fill="#1B1E27" data-sentry-element="rect" data-sentry-source-file="index.tsx" />
      <rect x="20.0796" y="29.7012" width="4.84" height="4.84" rx="2.42" fill="#1B1E27" data-sentry-element="rect" data-sentry-source-file="index.tsx" />
    </svg>;
};
export default Alert;